/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'

const DEBUGMODE:boolean = true

class OcularAnalitycs {
  analityc:any = null

  async saveAnalityc (finish = false) {
    const widget = store.state.widget.data

    if (!widget || !this.analityc) {
      return false
    }

    const data = {
      route: `${process.env.VUE_APP_ANALITYCS_API_URL}/v1/widget/${this.analityc.analitycId ? `updateAnalitycs/${this.analityc.analitycId}` : 'createAnalitycs' }`,
      method: this.analityc.analitycId ? 'put' : 'post',
      params: this.analityc
    }

    data.params.organizationUuId = widget.organization.uuid
    data.params.widgetUuId = widget.uuid

    if (!data.params.widgetUuId) {
      return false
    }

    return fetch(data.route, {
        method: data.method,
        body: JSON.stringify(data.params),
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Connection': 'keep-alive',
          'Accept': '*'
        }
      })
      .then((response) => response.text())
      .then((response) => {
        const res = JSON.parse(response)

        if (!res) {
          window.parent.postMessage('analitycsStorage.resetStorageData()', '*')
          return false
        }

        if (res.status !== 200) {
          console.warn(`saveAnalityc ERROR: status ${res.status}`, res)
          return false
        }

        let analitycId

        if (res.body.result && res.body.result.value && res.body.result.value._id) {
          analitycId = res.body.result.value._id
        } else if (res.body.writeAnalitycsResponse && res.body.writeAnalitycsResponse.id) {
          analitycId = res.body.writeAnalitycsResponse.id
        }

        if (finish) {
          window.parent.postMessage('analitycsStorage.resetStorageData()', '*')
        } else {
          this.analityc.analitycId = analitycId
          window.parent.postMessage(`analitycsStorage.updateStorageData(${JSON.stringify(this.analityc)})`, '*')
        }
      })
      .catch((error) => {
        console.error('saveAnalityc', error)
      })
  }

  addHistoryItem(historyItem:any, analityc:any) {
    try {
      if (historyItem.actionType.id !== 'SVAH') {
        this.analityc = analityc
        const finish = historyItem.actionType.id === 'FNAN'
        this.saveAnalityc(finish)
      }
    } catch (error) {
      if (DEBUGMODE) {
        console.error('Ocular Analitics Error: addHistoryItem() function', error)
      }
    }
  }

  unshiftHistory(historyItem:any) {
    window.parent.postMessage(`analitycsStorage.addHistoryItem(${JSON.stringify(historyItem)}, ${JSON.stringify(Vue.prototype.$cityMap.country)})`, '*')
  }

  widgetAnalitycsEvent (event:any) {
    if (!Vue.prototype.$organization.analitycs()) {
      return false
    }

    const date = new Date()
    const siteUrl = `${Vue.prototype.$widget.parentLocation.origin}${Vue.prototype.$widget.parentLocation.pathname}`
    const widgetUrl = `${window.location.origin}${window.location.pathname}`

    const actionTypes = [
      {
        id: 'SVAH',
        action: 'saveAnalitycHistory'
      },
      {
        id: 'STAH',
        action: 'storeAnalitycHistory'
      },
      {
        id: 'FNAN',
        action: 'finishAnalityc'
      }
    ]
    const actionType = actionTypes.find((actionType) => actionType.id === event.actionType)

    if (!actionType) {
      console.log('Invalid actionType')
      return false
    }

    const functionalities = [
      {
        id: 1,
        name: 'Init Form'
      },
      {
        id: 2,
        name: 'Categories'
      },
      {
        id: 3,
        name: 'Attention types'
      },
      {
        id: 4,
        name: 'Calendar'
      },
      {
        id: 5,
        name: 'Permissions'
      },
      {
        id: 6,
        name: 'Queue'
      },
      {
        id: 7,
        name: 'Session'
      },
      {
        id: 8,
        name: 'Calification'
      },
      {
        id: 9,
        name: 'Ocular Ad'
      },
      {
        id: 10,
        name: 'Header'
      },
      {
        id: 11,
        name: 'Lobby'
      },
      {
        id: 12,
        name: 'Footer'
      },
      {
        id: 13,
        name: 'Thank you'
      },
      {
        id: 14,
        name: 'Questionnaire'
      }
    ]
    const functionality = functionalities.find((functionality) => functionality.id === event.functionality)

    if (!functionality) {
      console.log('Invalid functionality')
      return false
    }

    const historyInteractionTypes = [
      {
        id: 'OSSOIN',
        description: 'Information request.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OSSBAD',
        description: 'did not get what he was looking for.',
        type: 'BAD',
        icon: '<em class="fa fa-arrow-down text-danger"></em>'
      },
      {
        id: 'OSGOOD',
        description: 'got what he was looking for.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OSIFDV',
        description: 'interaction with view functionality.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OSNONV',
        description: 'interaction with view functionality.',
        type: 'BAD',
        icon: '<em class="fa fa-arrow-down text-danger"></em>'
      },
      {
        id: 'LEFTLB',
        description: 'left the lobby.',
        type: 'BAD',
        icon: '<em class="fa fa-arrow-down text-danger"></em>'
      },
      {
        id: 'OSBACK',
        description: 'return, regret, exit.',
        type: 'FINE',
        icon: '<em class="fa fa-grip-lines text-warning"></em>'
      },
      {
        id: 'OSEQUE',
        description: 'queue entry.',
        type: 'FINE',
        icon: '<em class="fa fa-grip-lines text-warning"></em>'
      },
      {
        id: 'OSLQUE',
        description: 'left the queue.',
        type: 'BAD',
        icon: '<em class="fa fa-arrow-down text-danger"></em>'
      },
      {
        id: 'OSSUCC',
        description: 'attended.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'QUEFIN',
        description: 'queue entry.',
        type: 'FINE',
        icon: '<em class="fa fa-grip-lines text-warning"></em>'
      },
      {
        id: 'OSINIT',
        description: 'Join the call.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OSFNSH',
        description: 'Ended on call.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OSCLFT',
        description: 'qualified.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OSCHAT',
        description: 'Use of chat.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OSSANA',
        description: 'schedule an appointment.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'OENTRY',
        description: 'entry.',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'CAMMER-SESSION-INFO',
        description: 'Cammer session info.',
        type: 'VERYBAD',
        icon: '<em class="fa fa-circle-exclamation text-warning"></em>'
      },
      {
        id: 'QSGOOD',
        description: 'completed questions',
        type: 'GOOD',
        icon: '<em class="fa fa-arrow-up text-success"></em>'
      },
      {
        id: 'QSBAD',
        description: 'empty questions',
        type: 'BAD',
        icon: '<em class="fa fa-arrow-down text-danger"></em>'
      }
    ]
    const historyInteractionType = historyInteractionTypes.find((historyInteractionType) => historyInteractionType.id === event.historyInteractionType)

    if (!historyInteractionType) {
      console.log('Invalid historyInteractionType')
      return false
    }

    const historyItem = {
      creationTime: date.toISOString(),
      action: event.action,
      detail: event.detail,
      actionType,
      functionality,
      functionalityData: event.functionalityData ? event.functionalityData : null,
      historyInteractionType,
      widgetUrl,
      siteUrl
    }

    this.unshiftHistory(historyItem)
  }
}

Vue.prototype.$ocularAnalitycs = new OcularAnalitycs()
const ocularAnalitycs = <any> new OcularAnalitycs()

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    ocularAnalitycs[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);
